module.exports = __webpack_public_path__ + "static/23-tat2B-030717c4c2b2f7a4d9b8b2028f1b7031.jpg";